import { createSlice } from "@reduxjs/toolkit";

const initialState = { message: null };

const messageSlice = createSlice({
  name: "message",
  initialState,
  reducers: {
    // Accept either a string or an object { text, type }
    setMessage: (state, action) => {
      const payload = action.payload;
      if (typeof payload === "string") {
        state.message = { text: payload, type: "error" };
      } else if (payload && typeof payload === "object") {
        state.message = {
          text: payload.text || payload.message || "",
          type: payload.type || "error",
        };
      } else {
        state.message = null;
      }
    },
    clearMessage: () => {
      return { message: null };
    },
  },
});

const { reducer, actions } = messageSlice;

export const { setMessage, clearMessage } = actions;
export default reducer;
